module.exports = __webpack_public_path__ + "img/Freek_03.cce17942.jpg";